/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import React, {Suspense} from 'react'
import {BrowserRouter as Router, Route, Routes, Outlet, Navigate} from 'react-router-dom'

import Navigation from './Navigation'
import OverallProgress from './OverallProgress'
import Popups from './Popups'
import Overlays from '~/components/Overlays'
import {useAuth} from '~/hooks/useAuth'

const LoginPage = React.lazy(() => import('~/components/pages/LoginPage'))
// const RegisterPage = React.lazy(() => import('~/components/pages/RegisterPage'))
const RestorePasswordPage = React.lazy(() => import('~/components/pages/RestorePasswordPage'))
const SpacesPage = React.lazy(() => import('~/components/pages/SpacesPage'))
const SpacePage = React.lazy(() => import('~/components/pages/SpacePage'))
const UsersPage = React.lazy(() => import('~/components/pages/UsersPage'))
const UserPage = React.lazy(() => import('~/components/pages/UserPage'))
const SourcesPage = React.lazy(() => import('~/components/pages/sourcesPage/SourcesPage'))
const VectorStoreDocumentsPage = React.lazy(() => import('~/components/pages/vectorStoreDocumentsPage/VectorStoreDocumentsPage'))
const VectorStoreSearchPage = React.lazy(() => import('~/components/pages/vectorStoreSearchPage/VectorStoreSearchPage'))
const AssistantsPage = React.lazy(() => import('~/components/pages/AssistantsPage'))
const AssistantPage = React.lazy(() => import('~/components/pages/assistantPage/AssistantPage'))
const ProfilePage = React.lazy(() => import('~/components/pages/ProfilePage'))
const ChatsPage = React.lazy(() => import('~/components/pages/ChatsPage'))
const ModelsPage = React.lazy(() => import('~/components/pages/ModelsPage'))

export default function App() {
    const {auth, ready} = useAuth()

    if (!ready)
        return <ProgressLayout/>

    const isRoot = auth?.profile?.user.type == 'root'
    const isAdmin = auth?.profile?.user.type == 'admin'

    return (
        <Router>
            <Suspense fallback={auth?.profile ? <SuspenseLayout/> : <ProgressLayout/>}>
                <Routes>
                    <Route element={<>
                        <Outlet/>
                        <Overlays/>
                        <Popups/>
                    </>}>
                        <Route path='/login' element={auth?.profile ? <Navigate replace to='/chats'/> : <LoginPage/>}/>
                        {/* <Route path='/login/register' element={auth.profile ? <Navigate replace to='/home'/> : <RegisterPage/>}/> */}
                        <Route path='/login/restore' element={auth?.profile ? <Navigate replace to='/chats'/> : <RestorePasswordPage/>}/>
                        <Route path='/*' element={auth?.profile ? <Layout/> : <Navigate replace to='/login'/>}>
                            <Route path='*' element={<Navigate to='/chats'/>}/>
                            <Route path='models' element={<ModelsPage/>}/>

                            {(isRoot || isAdmin) && <>
                                <Route
                                    path='administration'
                                    element={isRoot
                                        ? <Navigate replace to='/administration/spaces'/>
                                        : <Navigate replace to='/administration/users'/>
                                    }
                                />
                                {isRoot && <>
                                    <Route
                                        path='administration/spaces'
                                        element={isRoot
                                            ? <SpacesPage/>
                                            : <Navigate replace to='/administration'/>
                                        }
                                    />
                                    <Route
                                        path='administration/spaces/:spaceId'
                                        element={isRoot
                                            ? <SpacePage/>
                                            : <Navigate replace to='/administration'/>
                                        }
                                    />
                                </>
                                }
                                <Route path='administration/users' element={<UsersPage/>}/>
                                <Route path='administration/users/:userId' element={<UserPage/>}/>
                            </>}

                            <Route path='sources' element={<SourcesPage/>}/>
                            <Route path='sources/vector-stores/:vectorStoreId/documents' element={<VectorStoreDocumentsPage/>}/>
                            <Route path='sources/vector-stores/:vectorStoreId/search' element={<VectorStoreSearchPage/>}/>

                            <Route path='assistants' element={<AssistantsPage/>}/>
                            <Route path='assistants/:assistantId' element={<AssistantPage/>}/>
                            <Route path='assistants/:assistantId/chats' element={<AssistantPage/>}/>
                            <Route path='assistants/:assistantId/chats/:chatId' element={<AssistantPage/>}/>

                            <Route path='chats' element={<ChatsPage/>}/>
                            <Route path='chats/:chatId' element={<ChatsPage/>}/>

                            <Route path='profile' element={<ProfilePage/>}/>
                        </Route>
                    </Route>
                </Routes>
            </Suspense>
        </Router>
    )
}

function ProgressLayout() {
    return (
        <div className='screen'>
            <OverallProgress/>
        </div>
    )
}

function Layout() {
    return (
        <div className='page flex'>
            <Navigation/>
            <div className='flex-item flex-item_wide h-100 w-fix'>
                <Outlet/>
            </div>
        </div>
    )
}

function SuspenseLayout() {
    return <div className='page flex'>
        <Navigation/>
        <div className='flex-item flex-item_wide h-100'>
            <OverallProgress/>
        </div>
    </div>
}
